import { getMessageWhatsapp } from '@helpers/helper.rendering'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import useQueryProperty from '@hooks/useQueryProperty'
import React, { useState, useEffect, Fragment } from 'react'
import { RealEstateDataFooterData } from 'types'
interface ExternalProps {
  developmentID?: string
  propertyID?: string
}

const isBrowser = typeof window !== 'undefined'

type CombinedProps = RealEstateDataFooterData & ExternalProps

const Whatsapp_Element = ({
  global_data,
  developmentID,
  propertyID,
  hidden,
  advanced_whatsapp,
}: CombinedProps) => {
  const tokkoKey = global_data.pageConfig.keys.tokko

  const development = useQueryDevelopment(developmentID, tokkoKey)
  const property = useQueryProperty(propertyID, tokkoKey)
  const [closeWhatsapp, setCloseWhatsapp] = useState(true)
  const branch_office = global_data.branches
  const contact_data = global_data.contact_data
  const branchesWa = hidden

  const [isComponentMounted, setIsComponentMounted] = useState(false)

  console.log(advanced_whatsapp)

  useEffect(() => {
    setIsComponentMounted(true)
  }, [])
  const get_whatsApp_element = () => {
    if (isBrowser && isComponentMounted) {
      if (branchesWa) {
        if (branch_office?.length === 0) {
          return (
            <div>
              <a
                href={
                  'https://web.whatsapp.com/send?text=' +
                  getMessageWhatsapp(development?.data, property?.data, location?.href) +
                  '&phone=+' +
                  branch_office[0]?.contact_data.phonesLine[0].replaceAll('-', '')
                }
                target="_blank"
                className={'icon-whatsapp contact-btn d-none d-lg-flex '}
              ></a>
              <a
                href={
                  'https://api.whatsapp.com/send?text=' +
                  getMessageWhatsapp(development?.data, property?.data, location?.href) +
                  '&phone=+' +
                  branch_office[0]?.contact_data.phonesLine[0].replaceAll('-', '')
                }
                target="_blank"
                className={'icon-whatsapp contact-btn d-flex d-lg-none '}
              ></a>
            </div>
          )
        } else {
          return (
            <>
              <div
                onClick={() => setCloseWhatsapp(!closeWhatsapp)}
                className={
                  'icon-whatsapp contact-btn d-lg-flex div-whatsapp ' +
                  (closeWhatsapp ? 'close' : 'open')
                }
              >
                <div
                  className={'float-whatsapp ' + (branch_office?.length === 1 ? 'only-one' : '')}
                >
                  {branch_office
                    .sort((a, b) => (advanced_whatsapp ? b.id - a.id : a.id - b.id))
                    ?.map(
                      (element, index) =>
                        element.contact_data.phonesMobile.length > 0 && (
                          <Fragment key={index}>
                            <a
                              href={
                                'https://web.whatsapp.com/send?text=' +
                                getMessageWhatsapp(
                                  development?.data,
                                  property?.data,
                                  location?.href,
                                ) +
                                '&phone=+' +
                                element.contact_data.phonesMobile[0].replaceAll('-', '')
                              }
                              target="_blank"
                              className={'contact-btn d-none d-lg-flex text-center '}
                            >
                              {element.name}
                            </a>
                            <a
                              href={
                                'https://api.whatsapp.com/send?text=' +
                                getMessageWhatsapp(
                                  development?.data,
                                  property?.data,
                                  location?.href,
                                ) +
                                '&phone=+' +
                                element.contact_data.phonesMobile[0].replaceAll('-', '')
                              }
                              target="_blank"
                              className={'contact-btn d-flex d-lg-none text-center'}
                            >
                              {element.name}
                            </a>
                          </Fragment>
                        ),
                    )}
                </div>
              </div>
            </>
          )
        }
      } else {
        return (
          <>
            <a
              href={
                'https://web.whatsapp.com/send?text=' +
                getMessageWhatsapp(development?.data, property?.data, location?.href) +
                '&phone=+' +
                contact_data?.phoneMobile![0]?.replaceAll('-', '')
              }
              target="_blank"
              className={'icon-whatsapp contact-btn d-none d-lg-flex '}
            ></a>
            <a
              href={
                'https://api.whatsapp.com/send?text=' +
                getMessageWhatsapp(development?.data, property?.data, location?.href) +
                '&phone=+' +
                contact_data?.phoneMobile![0]?.replaceAll('-', '')
              }
              target="_blank"
              className={'icon-whatsapp contact-btn d-flex d-lg-none '}
            ></a>
          </>
        )
      }
    }
  }
  return isComponentMounted ? (
    <div className={'fixed-bar position-fixed '}>
      <div className={'pulse-border'}></div>
      {get_whatsApp_element()}
    </div>
  ) : (
    <div></div>
  )
}

export default Whatsapp_Element
